import React from 'react';
import './Home.css';
import EmblaCarousel from '../Carousel/Carousel';
import slide1 from '../../Assets/Images/slide.jpg';
import slide2 from '../../Assets/Images/slide2.jpg';
import slide3 from '../../Assets/Images/slide3.jpg';

const Home = () => {
  const welcomeText = "Welcome to Cowdog Technologies!";
  const slides = [
    { src: slide1, alt: "Slide 1", loading: "lazy", caption: "Macintosh Battery Repairs" },
    { src: slide2, alt: "Slide 2", loading: "lazy", caption: "Original Xbox Modchip, Recap, & Ram Upgrades" },
    { src: slide3, alt: "Slide 3", loading: "lazy", caption: "Vintage Macintosh Restorations" }
  ];

  return (
    <div className="home">
      <main className="home-main">
        <header className="home-header">
          <h1>
            {welcomeText.split('').map((letter, index) =>
              letter === ' ' ? (
                <span key={index} className="space-between-words"> </span>
              ) : (
                <span key={index} className="vintage-letter">{letter}</span>
              )
            )}
          </h1>
          <p>The ultimate destination for tech solutions, modern and nostalgic!</p>
          <EmblaCarousel slides={slides} options={{ loop: true }} />
        </header>
      </main>
    </div>
  );
};

export default Home;